import React from "react";

const FiltersWrapper = ({children, label}) => {
    return (
        <div className="filters-wrapper">
            {label && <span className='big-label'>{label}</span>}
            {children}
        </div>
    )
}

export default FiltersWrapper;